import { RolesEndpoints } from "../api/admin/roles.endpoints";
import APIrequest from "../lib/axios";

export const RolesService = {
    async createRole(data) {
        try {
            const payload = {
                ...RolesEndpoints.createRole,
                bodyData: data,
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async getAllRoles() {
        try {
            const payload = {
                ...RolesEndpoints.getAllRoles,
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async getRole(id) {
        try {
            const payload = {
                ...RolesEndpoints.getRole(id),
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async updateRole(id, data) {
        try {
            const payload = {
                ...RolesEndpoints.updateRole(id),
                bodyData: data,
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async deleteRole(id) {
        try {
            const payload = {
                ...RolesEndpoints.deleteRole(id),
            };
            const response = await APIrequest(payload);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
};
